export const roleTypes = {
  ADMIN: 'ADMIN',
  SUPER_ADMIN: 'SUPER_ADMIN',
  EDITOR: 'EDITOR',
  VIEWERS: 'VIEWERS',
};
